import {Info} from 'lucide-react'
import React from 'react'

type AttendanceV2GapNoticeProps = {
  text: string
  theme: 'light' | 'dark'
}

/** A capability gap the backend reported ("class-level subject attendance isn't available yet").
 *  Rendered as a muted notice so it reads as a limitation rather than as a result. */
const AttendanceV2GapNotice: React.FC<AttendanceV2GapNoticeProps> = ({text, theme}) => {
  const message = text?.trim()
  if (!message) return null

  const borderColor = theme === 'dark' ? 'rgba(255,255,255,0.18)' : 'rgba(0,0,0,0.1)'
  const cardBg = theme === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.03)'
  const textColor = theme === 'dark' ? 'rgba(255,255,255,0.8)' : '#6c757d'

  return (
    <div
      className='d-flex align-items-start gap-2 rounded-2 p-2 mt-1'
      style={{
        border: `1px solid ${borderColor}`,
        backgroundColor: cardBg,
        color: textColor,
        fontSize: '0.8rem',
        lineHeight: 1.45,
      }}
    >
      <Info size={14} style={{flexShrink: 0, marginTop: 2}} aria-hidden='true' />
      <div>{message}</div>
    </div>
  )
}

export default AttendanceV2GapNotice
